module.exports = __webpack_public_path__ + "static/img/data3.034a1547.png";